import axios from 'axios';
import Sortable from 'sortablejs';

export default class psProfileContacts {

    constructor() {
        const container = document.getElementById('profile-contacts');
        const list = container.querySelector('.contacts-list-wrapper');
        const search = document.getElementById('profile-contact-search');

        if (!(container && list && search)) {
            return;
        }

        this.container = container;
        this.listLoader = container.querySelector('.ajax-loading');

        this.listContainer = list;

        this.searchContainer = search;
        this.searchResult = search.querySelector('.search-result');
        this.searchLoader = search.querySelector('.ajax-loading');

        this._init();
    }

    _init() {
        this._initAddMenu();
        this._initEdit();
    }

    _initAddMenu() {
        // �ppna meny "L�gg till"
        const addButton = this.container.querySelector('.add-contacts-button');
        addButton && addButton.addEventListener('click', event => {
            var content = document.getElementById(event.target.getAttribute('aria-controls'));
            if (!content) {
                return;
            }

            const expanded = event.target.getAttribute('aria-expanded') === 'true';
            event.target.setAttribute('aria-expanded', !expanded);
            content.toggleAttribute('hidden', expanded);
        });

        const searchClose = this.searchContainer.querySelector('.close-button');
        searchClose && searchClose.addEventListener('click', () => {
            this.searchContainer.toggleAttribute('hidden', true);
            addButton && addButton.setAttribute('aria-expanded', false);

            // Open when we close the search box (mobile)
            if (window.innerWidth < 768) {
                const list = document.getElementById('collapsable-contacts-list');
                const expandedArrow = document.querySelector('[aria-controls="' + list.id + '"]');
                if (expandedArrow && expandedArrow.getAttribute('aria-expanded') !== 'true') {
                    expandedArrow.setAttribute('aria-expanded', true);
                    if (list) {
                        list.classList.remove('profile__mobile-hide');
                        expandedArrow.classList.add('profile__mobile-expand--modifier');
                    }
                }
            }

            this._toggleEditList(false);
        });

        this._initSearch();
        this._initAdd();
    }

    _initEdit() {
        // redigering ("kugghjul")
        const editButton = this.container.querySelector('.edit-contacts-button');
        editButton && editButton.addEventListener('click', event => {
            this._toggleEditList();
        });

        // borttagning
        this.listContainer.addEventListener('click', event => {
            if (!event.target.classList.contains('remove-contact')) {
                return;
            }

            event.preventDefault();

            this._toggleListLoader(true);

            const headers = {
                'Content-Type': 'text/plain'
            };

            const id = event.target.getAttribute('data-id');

            axios.post("/api/ps/profile/contacts/remove", { id })
                .then(() => {
                    event.target.parentElement.remove();
                    const link = document.querySelector('#collapsable-contacts-list a[data-id="' + id + '"]');
                    link && link.remove();
                })
                .catch(error => {
                    this._error(error.status);
                })
                .finally(() => {
                    this._toggleListLoader(false);
                });
        });
    }

    _initSearch() {
        const input = this.searchContainer.querySelector('.search-input');
        let timer;

        input && input.addEventListener('input', () => {
            clearTimeout(timer);
            this._toggleSearchLoader(true);

            timer = setTimeout(() => {
                if (input.value.length < 2) {
                    this.searchResult.innerHTML = '';
                    this._toggleSearchLoader(false);
                    return;
                }

                // { params: {} } g�r en querystring av objektet
                axios.get("/api/ps/profile/contacts/search", { params: { text: input.value } })
                    .then(response => {
                        this.searchResult.innerHTML = response.data;
                    })
                    .catch(error => {
                        this._error(error);
                    })
                    .finally(() => {
                        this._toggleSearchLoader(false);
                    });

            }, 650);
        });
    }

    _initAdd() {
        this.searchResult && this.searchResult.addEventListener('click', event => {
            if (!event.target.classList.contains('add-contacts')) {
                return;
            }

            event.preventDefault();

            this._toggleSearchLoader(true);

            const id = event.target.getAttribute('data-id');

            axios.post("/api/ps/profile/contacts/add", { id })
                .then(() => {
                    event.target.style.display = "none";

                    if (event.target.nextElementSibling) {
                        event.target.nextElementSibling.style.display = "block";
                    } else {
                        var img = document.createElement('img');
                        img.src = "/img/ps-icons/check.svg";
                        img.alt = "check";
                        event.target.parentNode.insertBefore(img, event.target.nextElementSibling);
                    }

                    axios.get("/api/ps/profile/contacts")
                        .then(response => {
                            this.container.querySelector('.contacts-list-wrapper').innerHTML = response.data; // inneh�ller b�de lista och sortable....
                            this._updateSortable();
                        })
                        .finally(() => {
                            this._toggleSearchLoader(false);
                        });
                })
                .catch(error => {
                    this._error(error);
                    this._toggleSearchLoader(false);
                });
        });

        document.addEventListener('DOMContentLoaded', () => this._updateSortable());
    }

    _toggleEditList(state) {
        const list = document.getElementById('collapsable-contacts-list');
        const editList = document.getElementById('profile-edit-contacts');
        const btn = this.container.querySelector(`[aria-controls="${editList.id}"]`);

        state = state == null ? !(btn.getAttribute('aria-expanded') === 'true') : state === true;

        list.toggleAttribute('hidden', state);
        editList.toggleAttribute('hidden', !state);
        btn.setAttribute('aria-expanded', state);
        btn.classList.toggle('checked', state);
    }

    _updateSortable() {
        if (this.sortable) {
            this.sortable.destroy();
        }

        const node = document.getElementById('profile-edit-contacts-wrapper');
        if (!node) {
            return;
        }

        const options = {
            handle: '.added-contact-item__drag-wrapper',
            onUpdate: event => {
                const items = event.from.querySelectorAll('.added-contact-item');
                if (!items.length) {
                    return;
                }

                const contacts = new Array(items.length);

                for (let i = 0; i < items.length; i++) {
                    items[i].setAttribute('data-index', i);
                    contacts[i] = items[i].getAttribute('data-id');
                }

                axios.post("/api/ps/profile/contacts/sort", contacts)
                    .then(response => {
                        // inneh�ller bara lista...
                        const div = document.createElement('div');
                        div.innerHTML = response.data;
                        const list = document.getElementById('collapsable-contacts-list');
                        list.replaceWith(div.firstElementChild);
                    })
                    .catch(error => {
                        this._error(error);
                    });
            }
        };

        this.sortable = Sortable.create(node, options);
    }

    _toggleSearchLoader(state) {
        this.searchLoader.toggleAttribute('hidden', !state);
    }

    _toggleListLoader(state) {
        this.listLoader.toggleAttribute('hidden', !state);
    }

    _error(error) {
        const id = error && error.response && error.response.status === 401 ? 'ps-profile-logged-out' : 'ps-profile-generic-error';
        alert(document.getElementById(id).value);
    }
}
